var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from "./BaseModel";
import BundleModel from "@/models/BundleModel";
import DiscountModel from '@/models/DiscountModel';
import FreeChoiceSetModel from "@/models/FreeChoiceSetModel";
var itemImagePlaceholder = ""; // temp
var ItemModel = /** @class */ (function (_super) {
    __extends(ItemModel, _super);
    function ItemModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.id;
        _this.assetId = hydrated.assetId;
        _this.base = hydrated.base;
        _this.bundle = hydrated.bundle;
        _this.categoryId = hydrated.categoryId;
        _this.description = hydrated.description;
        _this.discount = hydrated.discount;
        _this.freeChoices = hydrated.freeChoices;
        _this.fullSizeImage = hydrated.fullSizeImage;
        _this.image = hydrated.image;
        _this.name = hydrated.name;
        _this.optionIds = hydrated.optionIds;
        _this.outOfStock = hydrated.outOfStock;
        _this.parentAssetId = hydrated.parentAssetId;
        _this.basePrice = +(hydrated.basePrice);
        _this.price = hydrated.price;
        _this.hasExceptions = hydrated.hasExceptions;
        _this.prepColor = hydrated.prepColor;
        _this.divisibleNum = hydrated.divisibleNum;
        _this.__mc = 'ItemModel';
        return _this;
    }
    ItemModel.validateImage = function (baseUrl, url) {
        if (!BaseModel.validType(url, "string")) {
            return itemImagePlaceholder;
        }
        return "" + baseUrl + url;
    };
    ItemModel.prototype.isBundle = function () {
        var bundle = this.bundle;
        if (!bundle) {
            return false;
        }
        if (!this.hasDiscount()) {
            return false;
        }
        return true;
    };
    ItemModel.prototype.addFreeChoices = function (data) {
        var freeChoices = data.free_choices_sets || null;
        if (freeChoices) {
            this.freeChoices = new FreeChoiceSetModel(freeChoices);
        }
        return freeChoices;
    };
    ItemModel.prototype.generateVanityName = function () {
        var name = this.name;
        var hyphenate = name.replace(/\s+/g, '-');
        var removeCharacters = hyphenate.replace(/\.|\,|\'/g, '');
        return removeCharacters.toLowerCase();
    };
    ItemModel.prototype.hydrate = function (data) {
        var item = {};
        item["base"] = data.base || null;
        item["id"] = "" + data.asset_id || null;
        item["categoryId"] = "" + (data.category_id || 0);
        item["assetId"] = "" + data.asset_id || null;
        item["name"] = data.name || "N/A";
        item["description"] = data.description || "";
        item["parentAssetId"] = data.parent_asset_id || null;
        item["price"] = data.price || 0;
        item["basePrice"] = data.price || 0;
        var useImage = data.kiosk_img || data.menu_img;
        item["fullSizeImage"] = (data.fullscreen_img) ? ItemModel.validateImage(data.baseURL, data.fullscreen_img) : null;
        item["image"] = ItemModel.validateImage(data.baseURL, useImage);
        item["optionIds"] = data.option_ids;
        item['bundle'] = null;
        item["outOfStock"] = data.out_of_stock === "1";
        item['hasExceptions'] = data.hasExceptions || false;
        item['prepColor'] = data.prep_type_color || '#ffffff';
        item['divisible_num'] = data.divisible_num || 1;
        if (data.bundle) {
            item['bundle'] = new BundleModel(data.bundle);
        }
        if (data.default_discount) {
            item['discount'] = new DiscountModel(data.default_discount);
        }
        if (data.free_choices_sets) {
            item['freeChoices'] = new FreeChoiceSetModel(data.free_choices_sets);
        }
        return item;
    };
    ItemModel.prototype.hydrateFromStore = function (data) {
        var item = {};
        item["base"] = data.base || null;
        item["id"] = "" + data.id || null;
        item["categoryId"] = "" + (data.categoryId || 0);
        item["assetId"] = "" + data.assetId || null;
        item["name"] = data.name || "N/A";
        item["description"] = data.description || "";
        item["parentAssetId"] = data.parentAssetId || null;
        item["price"] = data.price || 0;
        item["basePrice"] = data.price || 0;
        item["fullSizeImage"] = data.fullSizeImage || (data.fullscreen_img) ? ItemModel.validateImage(data.baseURL, data.fullscreen_img) : null;
        item["image"] = data.image || ItemModel.validateImage(data.baseURL, data.kiosk_img);
        item["optionIds"] = data.optionIds || [];
        item['bundle'] = data.bundle || null;
        item['discounts'] = data.discounts || null;
        item['prepColor'] = data.prepColor || '#ffffff';
        if (data.freeChoices) {
            item['freeChoices'] = new FreeChoiceSetModel(data.free_choices_sets);
        }
        return item;
    };
    ItemModel.prototype.hasDiscount = function () {
        var discount = this.discount;
        if (!discount) {
            return false;
        }
        return true;
    };
    ItemModel.prototype.getMatchingId = function (assetId) {
        var matchingId = null;
        if (assetId === this.id) {
            matchingId = this.id;
        }
        else if (assetId === this.parentAssetId) {
            matchingId = this.parentAssetId;
        }
        return matchingId;
    };
    return ItemModel;
}(BaseModel));
export default ItemModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/ItemModel.ts
// module id = yLLG
// module chunks = 18